import nodeClient from "./node-client";

export const generateOTP = async (data) => {
  const response = await nodeClient.post(
    `/service/protected/v0/generate/otp`,
    data
  );
  return response.data.result;
};
